export default __webpack_public_path__ + "media/images/about/step-1.jpg";